module.exports = __webpack_public_path__ + "static/media/map.7b5bb398.png";